import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { MutableRefObject, ReactNode, useRef } from 'react';
import { Video } from '../../utils/api/videoApi';
import { getDefaultAspectRatio, getStreamingSrc } from '../../utils/helpers/video';
import { useDeviceVideo } from '../../utils/hooks/useDeviceVideo';
import { colors, spacing } from '../../utils/styleguide';
import PrimaryButton, { ButtonColor, ButtonVariant } from './buttons/PrimaryButton';
import OverlayVideoPlayer from './OverlayVideoPlayer';
import PlayArrow from './video/PlayArrow';

const Label = styled.div`
  display: flex;
  align-items: center;
`;

type VideoPlayButtonProps = {
  buttonLabel: ReactNode;
  buttonColor?: ButtonColor;
  buttonVariant?: ButtonVariant;
  landscapeVideo?: Video;
  portraitVideo?: Video;
};

const VideoPlayButton = ({
  buttonLabel,
  buttonColor,
  buttonVariant,
  landscapeVideo,
  portraitVideo,
}: VideoPlayButtonProps) => {
  const [showVideo, setShowVideo] = React.useState(false);
  const video = useDeviceVideo({ landscapeVideo, portraitVideo });
  const videoRef = useRef() as MutableRefObject<HTMLVideoElement>;

  return (
    <>
      <PrimaryButton
        label={
          <Label>
            <PlayArrow size="S" color={colors.black} />
            <span
              css={css`
                margin-left: ${spacing[2]}px;
              `}
            >
              {buttonLabel || 'Watch our video'}
            </span>
          </Label>
        }
        color={buttonColor || 'onLight'}
        variant={buttonVariant || 'solid'}
        size={'large'}
        onClick={() => setShowVideo(true)}
      />
      {showVideo && video && (
        <OverlayVideoPlayer
          src={getStreamingSrc({ video })}
          aspectRatio={getDefaultAspectRatio(video)}
          onClose={() => setShowVideo(false)}
          videoId={video?.id}
          videoRef={videoRef}
        />
      )}
    </>
  );
};

export default VideoPlayButton;
